import React from 'react';
import styles from './Testimonial.module.css';

const Testimonial = () => {
  return (
    <section className={styles.testimonial}>
      <div className={styles.container}>
        <h2 className={styles.heading}>
          <span className="gold-text">История успеха: как женщина с долгами изменила финансовое положение</span>
        </h2>
        <div className={styles.content}>
          <div className={styles.text}>
            <p>
              Мария, 45 лет, консультант по маркетингу из Екатеринбурга. Когда она заказала прогноз на 2025 год, у нее была сложная финансовая ситуация: долги, коллекторы буквально на пороге, нестабильный доход от фриланса.
            </p>
            <p className={styles.quote}>
              "Я была в отчаянии. Не знала, как выбраться из долговой ямы, и боялась сделать еще одну финансовую ошибку. Решила попробовать прогноз как последнюю попытку что-то изменить", - рассказывает Мария.
            </p>
            <p>
              В прогнозе она увидела конкретные даты для работы с финансами: денежные часы, дни грабителя богатства. Следовала рекомендациям, особенно внимательно относилась к указанным датам для финансовых операций.
            </p>
            <p>
              В первый же месяц произошло невероятное: один из коллекторов, с которым она вела переговоры, сам предложил оплатить ее долг. "Он сказал, что вошел в мое положение и хочет помочь. Никаких амурных дел не было - просто человечность. Я была в шоке", - вспоминает Мария.
            </p>
            <p>
              В течение года, следуя прогнозу и используя указанные даты для финансовых действий, Мария смогла погасить большую часть долгов, стабилизировать доход, найти новых клиентов, создать финансовую подушку безопасности.
            </p>
            <p className={styles.quote}>
              "Я жила по прогнозу каждый день. Каждая финансовая операция - в денежные часы, крупные решения - в дни грабителя богатства. Это действительно работает", - говорит Мария.
            </p>
            <p>
              Это не обещание быстрого обогащения. Это история о том, как правильное планирование, использование правильных инструментов в правильное время может изменить ситуацию, даже когда кажется, что выхода нет.
            </p>
          </div>
          <div className={styles.imageWrapper}>
            <img 
              src="https://strategy.annavision.me/wp-content/uploads/2025/12/4ab574cba317456cc19bedab01759e92_1766902211-1.png" 
              alt="Визуализация трансформации и успеха в 2026 году" 
              className={styles.testimonialImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;

